// @flow

import type {Action} from '../../types'
import type {MapState} from '../types'
import type {SetReadyPayload} from '../actions/setReady'

export function setReadyReducer(state: MapState, action: Action<SetReadyPayload>): MapState {

  return {
    ...state,
    isReady: true,
  }
}
